// @flow

import React, { useRef, useState } from "react";
import { localize } from "redux-i18n";

import { SchemaForm, Button, View, Text } from "@components";
import actionCreators from "@modules/service/actionCreator";
import type {
  ServiceSettingsContainer,
  ServiceSettings,
} from "@modules/service/reducer/service-settings/types";
import { split } from "@transformers/schema";

import uiSchema from "./ui-schema";

type Props = $Exact<{
  serviceSettings: Object,
  settings: ServiceSettingsContainer,
  schema: Object,
  editDisabed: boolean,
  clientId: ?number,
  updateSettings: typeof actionCreators.UpdateServiceSettings,
  ...PropsFromLocalize,
}>;

type OwnState = $Exact<{
  edit: boolean,
}>;

const SettingsNotices = props => {
  const formRef = useRef(null);
  const [edit, setEdit] = useState(false);

  const submitForm = () => {
    formRef.current.submit();
  };

  const toggleEdit = () => {
    setEdit(prev => !prev);
  };

  const submitHandler = (formData: Object) => {
    props.updateSettings({
      clientId: props.clientId,
      settings: {
        ...formData,
        rtwDiscussionType: "EMPLOYEE_LED",
        timeInAdvanceAbsenceCanBeOpened: 5184000, // 60 days in seconds
        allowEmployeeToUpdateAndCloseAbsencesInSameTransaction: true,
        allowEmployeeToOpenAndCloseAbsencesInSameTransaction: true,
      },
    });
    toggleEdit();
  };

  const getUiSchema = () => {
    return uiSchema(props.t);
  };

  const schema = () => {
    const modifiedSchema = {
      ...props.schema,
      properties: {
        ...props.schema.properties,
        announcement: {
          type: "string",
          title: props.t("ANNOUNCEMENT"),
          maxLength: 1000,
        },
        medicalOnly: {
          type: "string",
          title: props.t("NON_MEDICAL_RULE"),
        },
      },
    };

    return split(modifiedSchema, ["announcement", "medicalOnly"]);
  };

  return props.settings?.active ? (
    <View gap={4} className="gs-container">
      <View direction="row" justifyContent="space-between">
        <Text type="h6">{props.t("NOTICES")}</Text>
        <View direction="row" justifyContent="space-between" gap="4">
          {!edit ? (
            <Button
              materialIcon="edit"
              onClick={toggleEdit}
              disabled={props.editDisabed}
              size="small"
            >
              {props.t("EDIT")}
            </Button>
          ) : (
            <View direction="row" gap="4">
              <Button color="secondary" onClick={toggleEdit} size="small">
                {props.t("CANCEL")}
              </Button>
              <Button
                materialIcon="replay_circle_filled"
                className="ml-2"
                onClick={submitForm}
                size="small"
              >
                {props.t("SUBMIT")}
              </Button>
            </View>
          )}
        </View>
      </View>
      <SchemaForm
        schema={schema()}
        uiSchema={getUiSchema()}
        formData={props.settings.active}
        ref={formRef}
        readonly={!edit}
        onSubmit={submitHandler}
        externalSubmit
        boxGrid
      />
    </View>
  ) : (
    <div />
  );
};

export default localize()(SettingsNotices);
